import { AVAILABLEPLAYS } from "../../constants/action-types";
const initialState = {
    availableMarketingPlays: [],
    activePlay: []
}

const AvailablePlaysReducer = (state = initialState, action) => {
    switch (action.type) {

        case AVAILABLEPLAYS.GET_AVAILABLE_PLAYS: {
            return Object.assign({}, state, {
                availableMarketingPlays: action.payload
            });
        }
        case AVAILABLEPLAYS.ACTIVATE_PLAY: {
            return Object.assign({}, state, {
                activePlay: action.payload
            });
        }

        default:
            return state
    }

}

export default AvailablePlaysReducer